module.exports = __webpack_public_path__ + "static/media/si.5f2b7e17.webp";